<svg
  xmlns="http://www.w3.org/2000/svg"
  width="23"
  height="23"
  viewBox="0 0 23 23"
  fill="none"
  [ngStyle]="overrideStyle"
>
  <rect
    width="24"
    height="24"
    transform="translate(0.750977 0.221924)"
    fill="#232F3A"
  />
  <path
    d="M19.751 13.2219H5.75098V11.2219H19.751V13.2219Z"
    fill="white"
  />
</svg>
